module.exports = __webpack_public_path__ + "static/media/3040160000_01.757d46d1.jpg";